let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1xWId")).then(() => parcelRequire('5h8br'));